import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import history from '../../history';
import {
  fetchDocumentsByType,
  fetchEmployeeQualifications
} from '../../api/v4';
import {
  getActiveFolderSelector,
  getDocumentFoldersSelector
} from '../../selectors/documents';
import { getActiveLocationId } from '../../selectors/company';
import { getAccessLevel } from '../../selectors/users';
import { addDocumentsToFolderRequest } from '../../actions/documents';

import { Button, InputRow } from '../inputs';
import AddToFolderModal from '../../components/Modal/addToFolderModal';
import DocumentFolder from '../../components/DocumentFolder';
import HeaderAndFooter from '../../components/HeaderAndFooter';
import Header from '../../components/Header';
import List from '../../components/List';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';

export default function QualificationList(props) {
  const dispatch = useDispatch();
  const [documents, setDocuments] = useState([]);
  const [addToFolderModal, setAddToFolderModal] = useState(false);
  const [folderId, setFolderId] = useState('');
  const [documentIds, setDocumentIds] = useState([]);

  const accessLevel = useSelector(getAccessLevel);
  const location = useSelector(getActiveLocationId);
  const folderList = useSelector(getDocumentFoldersSelector);
  const activeFolder = useSelector(getActiveFolderSelector);
  const { isFromEmployee, employeeId } = props;

  useEffect(() => {
    if (isFromEmployee) {
      fetchEmployeeQualifications(employeeId).then(response =>
        setDocuments(response?.documents)
      );
    } else {
      fetchDocumentsByType('Qualification', activeFolder._id).then(
        setDocuments
      );
    }
  }, [isFromEmployee, employeeId, activeFolder]);

  const handleAddMultipleToFolders = () => {
    let addDocsToFolder = [];
    documents.forEach(document => {
      if (documentIds.indexOf(document._id) > -1) {
        addDocsToFolder.push(document._id);
      }
    });

    dispatch(
      addDocumentsToFolderRequest({
        documents: addDocsToFolder,
        documentFolderId: folderId,
        type: 'documents'
      })
    );
    setAddToFolderModal(false);
    setDocumentIds([]);
  };

  const header = (
    <Header
      title="Qualifications"
      rightButtons={[
        {
          color: 'green',
          text: 'Add Qualification',
          visible: accessLevel !== 100,
          onClick: () => history.push(`/app/qualificationContainer`)
        }
      ]}
    />
  );

  const columns = [
    { key: 'title', accessor: r => r.documentData?.qualificationType?.label },
    {
      key: 'employeeId',
      label: 'Employee Name',
      datatype: 'users',
      accessor: r => r.documentData.employeeId
    },
    {
      key: 'scheduledDate',
      datatype: 'futureDate',
      accessor: r => r.documentData.scheduledDate
    },
    { key: 'expires', datatype: 'futureDate' },
    { key: 'attachments', label: 'Certificate', datatype: 'attachments' }
  ];

  if (!location) {
    columns.splice(1, 0, {
      key: 'groupIds',
      label: 'Group/Est.',
      datatype: 'groups'
    });
  }
  return employeeId ? (
    <>
      <InputRow right>
        <Button
          color="green"
          text="Add Qualification"
          onClick={() => history.push(`/app/qualificationContainer`)}
        />
      </InputRow>

      <List
        data={documents}
        dataIsHash
        settings={columns}
        getRowId={r => r._id}
        rowClick={row => history.push(`/app/qualificationContainer/${row._id}`)}
        saveKey="qualificationList"
        actions={[
          {
            color: 'blue',
            label: 'Add to Folder',
            visible: accessLevel !== 100,
            onClick: ids => {
              setAddToFolderModal(true);
              setDocumentIds(ids);
            }
          }
        ]}
      />
    </>
  ) : (
    <HeaderAndFooter Header={header}>
      <ScrollToTopOnMount />
      <DocumentFolder content={documents} docType="Qualifcation" />
      <List
        data={documents}
        dataIsHash
        settings={columns}
        getRowId={r => r._id}
        rowClick={row => history.push(`/app/qualificationContainer/${row._id}`)}
        saveKey="qualificationList"
        actions={[
          {
            color: 'blue',
            label: 'Add to Folder',
            visible: accessLevel !== 100,
            onClick: ids => {
              setAddToFolderModal(true);
              setDocumentIds(ids);
            }
          }
        ]}
      />
      <AddToFolderModal
        isOpen={addToFolderModal}
        folderId={folderId}
        onRequestClose={() => setAddToFolderModal(false)}
        submitActions={() => handleAddMultipleToFolders()}
        folderOptions={folderList?.map(f => ({ value: f._id, label: f?.name }))}
        onChange={setFolderId}
      />
    </HeaderAndFooter>
  );
}
